import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { SchemaMarkup, type BreadcrumbItem } from "./SchemaMarkup";

interface BreadcrumbNavProps {
  items: BreadcrumbItem[];
}

export function BreadcrumbNav({ items }: BreadcrumbNavProps) {
  return (
    <>
      <SchemaMarkup type="breadcrumb" items={items} />
      <nav aria-label="Breadcrumb" className="flex items-center gap-1.5 text-sm text-gray-400 mb-8">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-1.5">
            {i > 0 && <ChevronRight className="w-3.5 h-3.5 text-gray-300" />}
            {i === items.length - 1 ? (
              <span className="text-gray-600 font-medium">{item.name}</span>
            ) : (
              <Link to={new URL(item.url).pathname} className="hover:text-gray-600 transition-colors">
                {item.name}
              </Link>
            )}
          </span>
        ))}
      </nav>
    </>
  );
}
